<template>
  <div class="el-tabs el-tabs--top el-base-tabs">
    <div class="el-tabs__header is-top">
      <div class="el-tabs__nav-wrap is-top">
        <div class="el-tabs__nav-scroll">
          <div class="el-tabs__nav is-top">
            <div
              v-for="item in props.tabListData"
              :key="item.name"
              class="el-tabs__item"
              :class="props.modelValue === item.name ? 'is-active' : ''"
              @click="handleClick(item.name)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { definePropType, mutable } from '@pit-element-plus/utils'
import type { TabListDatas } from './tabs'

defineOptions({
  name: 'TabsCard',
})

const props = defineProps({
  modelValue: {
    type: [String, Number],
  },
  tabListData: {
    type: definePropType<TabListDatas>(Array),
    default: () => mutable([]),
  },
  noCard: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits({
  change: (val: string | number) => val,
})

const handleClick = function (val: string | number) {
  if (val) {
    emit('change', val)
  }
}
</script>
